import api from 'lib/trpcClient';
import FormWrapper, { EqualisationFormValues } from './FormWrapper';
import { ActionRefLabels } from 'further-ui/labels';
import EqualiseActionsContent from './EqualiseActionsContent';
import { useParams } from 'react-router-dom';
import { useLayoutContext } from 'contexts/LayoutContext';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { useEqualisationSection } from '../EqualisationContext';

const EqualiseActions: React.FC<{
  baseCurrency: CurrencyCode;
}> = ({ baseCurrency }) => {
  const { id } = useParams<{ id?: string }>();
  const { selectedVehicleId } = useLayoutContext();
  const { currentSection } = useEqualisationSection();

  const { data: actionsData, isFetching } =
    api.equalisations.getEqualisationActionAllocations.useQuery(
      {
        equalisationSection: currentSection,
        vehicleId: selectedVehicleId ?? '',
        equalisationId: id ?? '',
      },
      {
        enabled: !!id && !!selectedVehicleId && !!currentSection,
      },
    );

  const actions = isFetching
    ? []
    : actionsData?.map((action) => ({
        ...action,
        actionId: action.actionId,
        actionType: ActionRefLabels[action.actionRef],
        originalAllocations: action.originalAllocations.map((allocation) => ({
          ...allocation,
          closeDate: allocation.closeDate.toUTCDate(),
          allocationAmountLcy: allocation.allocationAmountLcy ?? 0,
        })),
        newAllocations: action.newAllocations.map((allocation) => ({
          ...allocation,
          closeDate: allocation.closeDate.toUTCDate(),
          allocationAmountLcy: allocation.allocationAmountLcy ?? 0,
        })),
        linkedActions: action.linkedActions.map((linkedAction) => ({
          ...linkedAction,
          actionId: linkedAction.actionId,
          originalAllocations: linkedAction.originalAllocations.map(
            (allocation) => ({
              ...allocation,
              closeDate: allocation.closeDate.toUTCDate(),
              allocationAmountLcy: allocation.allocationAmountLcy ?? 0,
            }),
          ),
          newAllocations: linkedAction.newAllocations.map((allocation) => ({
            ...allocation,
            closeDate: allocation.closeDate.toUTCDate(),
            allocationAmountLcy: allocation.allocationAmountLcy ?? 0,
          })),
          originalRealisationAllocations:
            linkedAction.originalRealisationAllocations,
          newRealisationAllocations: linkedAction.newRealisationAllocations,
          newRealisationAllocationTotals:
            linkedAction.newRealisationAllocationTotals,
        })),
      })) ?? [];

  const formValues: EqualisationFormValues = {
    currentSection,
    actions: actions.map((action) => ({
      actionId: action.actionId,
      actionType: action.actionType,
      counterpartyLabel: action.counterpartyLabel,
      ledgerDate: action.ledgerDate,
      totalAmountLcy: action.totalAmountLcy,
      allocationRule: action.allocationRule,
      originalAllocations: action.originalAllocations,
      newAllocations: action.newAllocations,
      linkedActions: action.linkedActions,
    })),
  };

  return (
    <FormWrapper key={currentSection} values={formValues}>
      <EqualiseActionsContent
        isLoading={isFetching}
        baseCurrency={baseCurrency}
      />
    </FormWrapper>
  );
};

export default EqualiseActions;
